import React, { useState } from 'react';
import { Breadcrumbs } from '../../library/common/components';
import { routes } from '../../main/routes';
import { Link } from 'react-router-dom';

const Projects = (props) => {
  const [category, setCategory] = useState('todos');

  const getClass = (selectedCategory) =>
    category === selectedCategory ? 'active' : '';

  const crumbs = routes
    .filter(({ path }) => props.match.path.includes(path))
    .map(({ path, ...rest }) => ({
      path: Object.keys(props.match.params).length
        ? Object.keys(props.match.params).reduce(
          (path, param) => path.replace(
            `:${param}`, props.match.params[param]
          ), path
          )
        : path,
      ...rest
    }));

  const projs = [
    {
      id: '1',
      category: 'integral',
      name: 'Project 1',
    },
    {
      id: '2',
      category: 'cocina',
      name: 'Project 2',
    },
    {
      id: '3',
      category: 'baño',
      name: 'Project 3',
    },
    {
      id: '4',
      category: 'climatizacion',
      name: 'Project 4',
    },
    {
      id: '5',
      category: 'locales',
      name: 'Project 5',
    },
    {
      id: '6',
      category: 'electrica',
      name: 'Project 6',
    },
    {
      id: '7',
      category: 'integral',
      name: 'Project 7',
    },
    {
      id: '8',
      category: 'cocina',
      name: 'Project 8',
    },
    {
      id: '9',
      category: 'baño',
      name: 'Project 9',
    },
    {
      id: '10',
      category: 'climatizacion',
      name: 'Project 10',
    },
    {
      id: '11',
      category: 'climatizacion',
      name: 'Project 11',
    },
    {
      id: '12',
      category: 'climatizacion',
      name: 'Project 12',
    }
  ];

  return (
  <div className='projects-page'>
    <Breadcrumbs crumbs={crumbs} title={'Nuestros Proyectos'}/>
    <div className='content'>
      <ul className='selector'>
        <li className={getClass('todos')} onClick={() => setCategory('todos')}>Todos</li>
        <li className={getClass('integral')} onClick={() => setCategory('integral')}>integrales</li>
        <li className={getClass('cocina')} onClick={() => setCategory('cocina')}>cocinas</li>
        <li className={getClass('baño')} onClick={() => setCategory('baño')}>baños</li>
        <li className={getClass('climatizacion')} onClick={() => setCategory('climatizacion')}>climatización</li>
        <li className={getClass('locales')} onClick={() => setCategory('locales')}>Locales y oficinas comerciales</li>
        <li className={getClass('electrica')} onClick={() => setCategory('electrica')}>Instalación eléctrica</li>
      </ul>
      <div className='grid'>
        { projs.filter((project) => project.category === category || category === 'todos')
            .map((project) => (
              <Link to='projects/1'>
                <div className='square' key={project.id}>
                  <div>
                    <span>{ project.name }</span>
                    <strong>+<small>Saber más</small></strong>
                  </div>
                </div>
              </Link>
        ))}
      </div>
    </div>
  </div>
)};

export default Projects;
